import type {
  PartnershipReferralsQuery_partnership_OdProtosPartnershipServices_Partnership_Query_getReferralsForSellerInput_OdProtosPartnershipServices_GetReferralsForSellerInputResponse_referrals_OdProtosPartnershipData_Referral as Referral,
  PartnershipReferralsQuery_partnership_OdProtosPartnershipServices_Partnership_Query_getReferralInvitation_OdProtosPartnershipServices_GetReferralInvitationResponse_invitation_OdProtosPartnershipData_ReferralInvitation as ReferralInvitation,
} from 'growth/__generated__/usePartnershipReferralStep';

/** Agent refer/represent choice or agent referral form (unknown attribution on the agency referral). */
export type AgentReferralStep = {
  type: 'agent-referral';
  agentReferral: Referral;
  referralInvitiationPaymentEligibility: boolean;
};

/** Seller accepts or declines a pending referral invitation. */
export type CustomerReferralAcceptanceStep = {
  type: 'customer-referral-acceptance';
  referralInvitation: ReferralInvitation;
  referralInvitiationPaymentEligibility: boolean;
};

export type ReferralStep = AgentReferralStep | CustomerReferralAcceptanceStep;

interface PartnershipReferralResponse {
  loading: boolean;
  partnershipReferralStep: ReferralStep | undefined;
}

/** Returns the partnership referral step a customer must complete, if any */
export const usePartnershipReferralStep = (
  _sellerInputUUID?: string,
): PartnershipReferralResponse => {
  return {
    loading: false,
    partnershipReferralStep: undefined,
  };
};
